import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

const LOGO = "/tresses_logo_full.png";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [sent, setSent] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
            setSent(true);
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail, "Couldn't send reset link — please try again"));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-6 py-12 grain bg-[#FBF6F0]" data-testid="forgot-password-page">
            <div className="w-full max-w-md">
                <Link to="/" className="flex items-center gap-4 mb-12">
                    <img src={LOGO} alt="The Tresses — Unisex Salon" className="h-32 w-auto object-contain" data-testid="auth-logo" />
                </Link>

                {sent ? (
                    <div className="card-luxe grain p-8" data-testid="forgot-password-sent">
                        <div className="text-overline text-[#8F622C]">Check Your Inbox</div>
                        <h1 className="font-serif-display text-3xl text-[#3D0C1F] mt-3">Reset link sent.</h1>
                        <p className="text-sm text-[#7A5262] mt-4">
                            If an account exists for <span className="text-[#3D0C1F]">{email}</span>, we&apos;ve sent a password
                            reset link valid for the next 1 hour. Please check your inbox (and spam folder).
                        </p>
                        <Link to="/login" className="btn-gold w-full justify-center mt-8" data-testid="forgot-back-to-login">
                            Return to sign in
                        </Link>
                    </div>
                ) : (
                    <>
                        <div className="text-overline">Forgot Password</div>
                        <h1 className="font-serif-display text-4xl text-[#3D0C1F] mt-3">Reset your password.</h1>
                        <p className="text-sm text-[#7A5262] mt-2">Enter your email and we&apos;ll send you a reset link.</p>

                        <form onSubmit={onSubmit} className="mt-10 space-y-5" data-testid="forgot-password-form">
                            <div>
                                <label className="text-overline">Email</label>
                                <input
                                    type="email"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full bg-[#FDF0EC] border border-[#6B1535]/15 px-4 py-3 mt-2 focus:border-[#C29A5B] outline-none text-[#3D0C1F]"
                                    placeholder="you@elegance.com"
                                    data-testid="forgot-email"
                                />
                            </div>
                            <button type="submit" disabled={submitting} className="btn-gold w-full justify-center disabled:opacity-50" data-testid="forgot-submit">
                                {submitting ? "Sending…" : "Send reset link"}
                            </button>
                        </form>
                    </>
                )}

                <p className="text-sm text-[#7A5262] mt-8 text-center">
                    Remember it?{" "}
                    <Link to="/login" className="text-[#8F622C] hover:text-[#3D0C1F]" data-testid="forgot-to-login">Sign in</Link>
                </p>
                <div className="text-center mt-6 pt-6 border-t border-[#6B1535]/10">
                    <Link to="/" className="text-[0.65rem] tracking-[0.22em] uppercase text-[#7A5262] hover:text-[#8F622C]" data-testid="forgot-back-home">
                        ← Back to home
                    </Link>
                </div>
            </div>
        </div>
    );
}
